export default "/fonts/RV-Harmonia-SemiBold.ttf?3f02931b4cd3e29e9cd0809e28e6186f";